module.exports = "/assets/images/d3f5101e9405cbe2b11a99a2d9117c1b.jpg";